import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../chartTemplate";
import * as d3 from "d3";

/* 
dc chart object
 */
const fodderChartFunc = (divRef, ndx) => {
    //  external functions remove empty  bins
    function remove_empty_bins(source_group, key_to_remove) {
        return {
            all: function () {
                return source_group.all().filter(function (d) {
                    return d.key !== null;
                });
            },
        };
    }
    //  dimension on topographical  conditions
    const fodder_availlability = ndx.dimension((d) => d.fodder_feed_availability);
    //  group by flood prone areas and drought prone areas
    const fodder_availlability_grp = fodder_availlability.group().reduceCount();


    var fodder_availlability_bins = remove_empty_bins(fodder_availlability_grp,null);
 

    const chart = dc.rowChart(divRef); // instance of the dc row chart
    chart
        .width(220) // set chart  width
        .height(150) // set  chart height 
        .elasticX(true) 
        .dimension(fodder_availlability)
        .group(fodder_availlability_bins)
        .label((d) => d.key)
        .colors(d3.scaleOrdinal().domain([0, 1]).range(["#F9E0A4", "#80AED5"]))
        .margins({ top: 20, right: 20, bottom: 20, left: 0 })
        .transitionDuration(1500);
    
    chart.xAxis().ticks(0);
  
    return chart;
};

export const FodderChart = (props) => (
    // pass the chart for rendering
    <ChartTemplate chartFunction={fodderChartFunc} />
);
